// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nightbot-StatGraphs-module__notActive-fhpy5 {
  opacity: 0.75;
}

.nightbot-StatGraphs-module__tabContainer-wCxrm {
  display: flex;
  border-bottom: 1px solid var(--background-secondary);
}

.nightbot-StatGraphs-module__tabContainer-wCxrm .nightbot-StatGraphs-module__tab-FQHs8 {
    flex: 1;
    padding: 0px;
    height: -moz-fit-content;
    height: fit-content;
    justify-content: left;
  }

.nightbot-StatGraphs-module__tabContainer-wCxrm .nightbot-StatGraphs-module__tabInner-_UzRq {
    height: -moz-fit-content;
    height: fit-content;
    justify-content: left;
    text-align: left;
    padding: 16px 24px;
  }

.nightbot-StatGraphs-module__tabContainer-wCxrm .nightbot-StatGraphs-module__tabLabel-e35FR {
    width: 100%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 4px;
  }

@media (max-width: 768px) {

.nightbot-StatGraphs-module__tabContainer-wCxrm .nightbot-StatGraphs-module__tabLabel-e35FR {
      flex-direction: column;
      align-items: flex-start;
  }
    }

.nightbot-StatGraphs-module__tabContainer-wCxrm .nightbot-StatGraphs-module__tabLabel-e35FR p {
      line-height: 0.8;
    }

.nightbot-StatGraphs-module__tabContainer-wCxrm .nightbot-StatGraphs-module__tabLabel-e35FR .nightbot-StatGraphs-module__tabTitle-gt4PP {
      width: 100%;
      color: var(--text-secondary);
      --text-color: var(--text-secondary);
    }

.nightbot-StatGraphs-module__tabContainer-wCxrm .nightbot-StatGraphs-module__tabLabel-e35FR .nightbot-StatGraphs-module__tabTotal-o2yLX {
      font-size: 36px;
      line-height: 1;
      color: var(--text-primary);
    }

.nightbot-StatGraphs-module__tabContainer-wCxrm .nightbot-StatGraphs-module__tabLabel-e35FR .nightbot-StatGraphs-module__tabDelta-gVanb {
      flex: 1;
      display: flex;
      flex-direction: column;
      gap: 4px;
    }

.nightbot-StatGraphs-module__tabContainer-wCxrm .nightbot-StatGraphs-module__tabLabel-e35FR .nightbot-StatGraphs-module__tabDelta-gVanb .nightbot-StatGraphs-module__tabDeltaValue-ShzPZ {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
      }

.nightbot-StatGraphs-module__tabContainer-wCxrm .nightbot-StatGraphs-module__tabLabel-e35FR .nightbot-StatGraphs-module__tabDeltaText-jfeLs {
      color: var(--text-primary);
    }

.nightbot-StatGraphs-module__tabContainer-wCxrm .nightbot-StatGraphs-module__tabLabel-e35FR .nightbot-StatGraphs-module__positive-raJGq {
      color: var(--color-success);
      --text-color: var(--color-success);
    }

.nightbot-StatGraphs-module__tabContainer-wCxrm .nightbot-StatGraphs-module__tabLabel-e35FR .nightbot-StatGraphs-module__negative-ZUZmg {
      color: var(--color-negative);
      --text-color: var(--color-negative);
    }

.nightbot-StatGraphs-module__tabContainer-wCxrm .nightbot-StatGraphs-module__tabLabel-e35FR .nightbot-StatGraphs-module__neutral-vZ35w {
      color: var(--color-neutral);
      --text-color: var(--color-neutral);
    }

.nightbot-StatGraphs-module__panel-vdz3E {
  /* TODO: Remove !important usage when Panel.tsx is updated, 
  chakra's inline styles are overriding this */
  padding: 0px !important;
  display: flex;
  flex-direction: column;
}

.nightbot-StatGraphs-module__panel-vdz3E,
.nightbot-StatGraphs-module__panelEmpty-ixHM0 {
  height: 400px;
}

.nightbot-StatGraphs-module__panelEmpty-ixHM0 {
  display: grid;
  align-items: center;
  justify-items: center;
  place-items: center;
}

.nightbot-StatGraphs-module__graphContent-wH00h {
  flex: 1;
  display: block;
}

.nightbot-StatGraphs-module__tooltip-uiWPX {
  padding: 8px;
  padding: 12px 0px !important;
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-width: 200px;
}

.nightbot-StatGraphs-module__tooltip-uiWPX .nightbot-StatGraphs-module__divider-gvgB4 {
    width: 100%;
  }

.nightbot-StatGraphs-module__tooltip-uiWPX .nightbot-StatGraphs-module__tooltipDate-CGRya {
    padding: 0px 12px;
  }

.nightbot-StatGraphs-module__tooltip-uiWPX .nightbot-StatGraphs-module__tooltipLabel-DdZJg {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    padding: 0px 12px;
  }

.nightbot-StatGraphs-module__tooltipGlyph-iyz4d {
  width: 16px;
  height: 16px;
}

[data-mantine-color-scheme='dark']:root .nightbot-StatGraphs-module__messageGlyph-PzNOO {
    color: var(--mantine-primary-color-5);
    fill: var(--mantine-primary-color-9);
  }

[data-mantine-color-scheme='dark']:root .nightbot-StatGraphs-module__commandGlyph-txyOK {
    color: var(--mantine-color-green-5);
    fill: var(--mantine-color-green-9);
  }

[data-mantine-color-scheme='dark']:root .nightbot-StatGraphs-module__timeoutGlyph-fgKJI {
    color: var(--mantine-color-pink-5);
    fill: var(--mantine-color-pink-9);
  }

[data-mantine-color-scheme='light']:root .nightbot-StatGraphs-module__messageGlyph-PzNOO {
    color: var(--mantine-primary-color-5);
    fill: var(--mantine-primary-color-2);
  }

[data-mantine-color-scheme='light']:root .nightbot-StatGraphs-module__commandGlyph-txyOK {
    color: var(--mantine-color-green-5);
    fill: var(--mantine-color-green-2);
  }

[data-mantine-color-scheme='light']:root .nightbot-StatGraphs-module__timeoutGlyph-fgKJI {
    color: var(--mantine-color-pink-5);
    fill: var(--mantine-color-pink-2);
  }

.nightbot-StatGraphs-module__grid-0wXaH {
  stroke: var(--background-secondary);
}
`, "",{"version":3,"sources":["webpack://./src/components/dashboard/StatGraphs.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,oDAAoD;AA6EtD;;AA3EE;IACE,OAAO;IACP,YAAY;IACZ,wBAAmB;IAAnB,mBAAmB;IACnB,qBAAqB;EACvB;;AAEA;IACE,wBAAmB;IAAnB,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;EACpB;;AAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,QAAQ;EAuDV;;AArDE;;AAPF;MAQI,sBAAsB;MACtB,uBAAuB;EAmD3B;IAlDE;;AAEA;MACE,gBAAgB;IAClB;;AAEA;MACE,WAAW;MACX,4BAA4B;MAC5B,mCAAmC;IACrC;;AAEA;MACE,eAAe;MACf,cAAc;MACd,0BAA0B;IAC5B;;AAEA;MACE,OAAO;MACP,aAAa;MACb,sBAAsB;MACtB,QAAQ;IAQV;;AANE;QACE,aAAa;QACb,mBAAmB;QACnB,QAAQ;QACR,mBAAmB;MACrB;;AAGF;MACE,0BAA0B;IAC5B;;AAEA;MACE,2BAA2B;MAC3B,kCAAkC;IACpC;;AAEA;MACE,4BAA4B;MAC5B,mCAAmC;IACrC;;AAEA;MACE,2BAA2B;MAC3B,kCAAkC;IACpC;;AAIJ;EACE;8CAC4C;EAC5C,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EAAnB,qBAAmB;EAAnB,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAkBlB;;AAhBE;IACE,WAAW;EACb;;AAEA;IACE,iBAAiB;EACnB;;AAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;EACnB;;AAGF;EACE,WAAW;EACX,YAAY;AACd;;AAGE;IACE,qCAAqC;IACrC,oCAAoC;EACtC;;AAEA;IACE,mCAAmC;IACnC,kCAAkC;EACpC;;AAEA;IACE,kCAAkC;IAClC,iCAAiC;EACnC;;AAIA;IACE,qCAAqC;IACrC,oCAAoC;EACtC;;AAEA;IACE,mCAAmC;IACnC,kCAAkC;EACpC;;AAEA;IACE,kCAAkC;IAClC,iCAAiC;EACnC;;AAGF;EACE,mCAAmC;AACrC","sourcesContent":[".notActive {\n  opacity: 0.75;\n}\n\n.tabContainer {\n  display: flex;\n  border-bottom: 1px solid var(--background-secondary);\n\n  .tab {\n    flex: 1;\n    padding: 0px;\n    height: fit-content;\n    justify-content: left;\n  }\n\n  .tabInner {\n    height: fit-content;\n    justify-content: left;\n    text-align: left;\n    padding: 16px 24px;\n  }\n\n  .tabLabel {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 4px;\n\n    @media (max-width: $mantine-breakpoint-sm) {\n      flex-direction: column;\n      align-items: flex-start;\n    }\n\n    p {\n      line-height: 0.8;\n    }\n\n    .tabTitle {\n      width: 100%;\n      color: var(--text-secondary);\n      --text-color: var(--text-secondary);\n    }\n\n    .tabTotal {\n      font-size: 36px;\n      line-height: 1;\n      color: var(--text-primary);\n    }\n\n    .tabDelta {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      gap: 4px;\n\n      .tabDeltaValue {\n        display: flex;\n        flex-direction: row;\n        gap: 4px;\n        align-items: center;\n      }\n    }\n\n    .tabDeltaText {\n      color: var(--text-primary);\n    }\n\n    .positive {\n      color: var(--color-success);\n      --text-color: var(--color-success);\n    }\n\n    .negative {\n      color: var(--color-negative);\n      --text-color: var(--color-negative);\n    }\n\n    .neutral {\n      color: var(--color-neutral);\n      --text-color: var(--color-neutral);\n    }\n  }\n}\n\n.panel {\n  /* TODO: Remove !important usage when Panel.tsx is updated, \n  chakra's inline styles are overriding this */\n  padding: 0px !important;\n  display: flex;\n  flex-direction: column;\n}\n\n.panel,\n.panelEmpty {\n  height: 400px;\n}\n\n.panelEmpty {\n  display: grid;\n  place-items: center;\n}\n\n.graphContent {\n  flex: 1;\n  display: block;\n}\n\n.tooltip {\n  padding: 8px;\n  padding: 12px 0px !important;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  max-width: 200px;\n\n  .divider {\n    width: 100%;\n  }\n\n  .tooltipDate {\n    padding: 0px 12px;\n  }\n\n  .tooltipLabel {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 12px;\n    padding: 0px 12px;\n  }\n}\n\n.tooltipGlyph {\n  width: 16px;\n  height: 16px;\n}\n\n@mixin dark-root {\n  .messageGlyph {\n    color: var(--mantine-primary-color-5);\n    fill: var(--mantine-primary-color-9);\n  }\n\n  .commandGlyph {\n    color: var(--mantine-color-green-5);\n    fill: var(--mantine-color-green-9);\n  }\n\n  .timeoutGlyph {\n    color: var(--mantine-color-pink-5);\n    fill: var(--mantine-color-pink-9);\n  }\n}\n\n@mixin light-root {\n  .messageGlyph {\n    color: var(--mantine-primary-color-5);\n    fill: var(--mantine-primary-color-2);\n  }\n\n  .commandGlyph {\n    color: var(--mantine-color-green-5);\n    fill: var(--mantine-color-green-2);\n  }\n\n  .timeoutGlyph {\n    color: var(--mantine-color-pink-5);\n    fill: var(--mantine-color-pink-2);\n  }\n}\n\n.grid {\n  stroke: var(--background-secondary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notActive": `nightbot-StatGraphs-module__notActive-fhpy5`,
	"tabContainer": `nightbot-StatGraphs-module__tabContainer-wCxrm`,
	"tab": `nightbot-StatGraphs-module__tab-FQHs8`,
	"tabInner": `nightbot-StatGraphs-module__tabInner-_UzRq`,
	"tabLabel": `nightbot-StatGraphs-module__tabLabel-e35FR`,
	"tabTitle": `nightbot-StatGraphs-module__tabTitle-gt4PP`,
	"tabTotal": `nightbot-StatGraphs-module__tabTotal-o2yLX`,
	"tabDelta": `nightbot-StatGraphs-module__tabDelta-gVanb`,
	"tabDeltaValue": `nightbot-StatGraphs-module__tabDeltaValue-ShzPZ`,
	"tabDeltaText": `nightbot-StatGraphs-module__tabDeltaText-jfeLs`,
	"positive": `nightbot-StatGraphs-module__positive-raJGq`,
	"negative": `nightbot-StatGraphs-module__negative-ZUZmg`,
	"neutral": `nightbot-StatGraphs-module__neutral-vZ35w`,
	"panel": `nightbot-StatGraphs-module__panel-vdz3E`,
	"panelEmpty": `nightbot-StatGraphs-module__panelEmpty-ixHM0`,
	"graphContent": `nightbot-StatGraphs-module__graphContent-wH00h`,
	"tooltip": `nightbot-StatGraphs-module__tooltip-uiWPX`,
	"divider": `nightbot-StatGraphs-module__divider-gvgB4`,
	"tooltipDate": `nightbot-StatGraphs-module__tooltipDate-CGRya`,
	"tooltipLabel": `nightbot-StatGraphs-module__tooltipLabel-DdZJg`,
	"tooltipGlyph": `nightbot-StatGraphs-module__tooltipGlyph-iyz4d`,
	"messageGlyph": `nightbot-StatGraphs-module__messageGlyph-PzNOO`,
	"commandGlyph": `nightbot-StatGraphs-module__commandGlyph-txyOK`,
	"timeoutGlyph": `nightbot-StatGraphs-module__timeoutGlyph-fgKJI`,
	"grid": `nightbot-StatGraphs-module__grid-0wXaH`
};
export default ___CSS_LOADER_EXPORT___;
